<template>
  <div>
    <el-checkbox-group v-model="text"
                    :disabled="disabled"
                    @change="handleChange">
      <el-checkbox v-for="(item,index) in dataSource"
                :key="item.baseId"
                :label="item[valueKey]">{{item[labelKey]}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>

  // import BaseLibraryManagement from '@/api/dict/Base_library_management';
  export default {
    name: 'LegalBaseCheckbox',
    data() {
      return {
        dataSource: [],
        text: []
      }
    },
    props: {
      value:[String, Number, Array],
      size: {
        type: String,
        default: 'medium'
      },

      disabled: {
        type: Boolean,
        default: false
      },

      labelKey: {
        type: String,
        default: 'baseName'
      },
      valueKey: {
        type: String,
        default: 'baseCode'
      },
      dictTypeCode: {
        type: String
      },
      showAll:{
        type: Boolean,
        default: false
      },
      parentCode: {
        type: String,
        default: '-1'
      }
    },

    methods: {
      findDict() {
        let params = {};
        params.baseType = this.dictTypeCode;
        let dictApi = new BaseLibraryManagement();
        if(this.showAll){
          // 如果现实该字典类型全部数据
          dictApi.getBaseList(params).then(res=>{
            this.dataSource = res.data;
          });
        }else{
          // 否则现实指定父级下的数据
          params.baseParent = this.parentCode;
          dictApi.getBaseTree(params).then(res=>{
            this.dataSource = res.data;
          });
        }

      },

      //选择回调
      handleChange(val) {
        this.text = val;
        this.$emit("input", val);

        // 获取选中的值
        let result = [];
        let valueKey = this.valueKey;
        if(val && val.length > 0){
          val.map(selected=>{
            let dict = this.dataSource.filter(function(item) {
              return item[valueKey] == selected;
            });
            result = result.concat(dict);
          })
        }
        this.$emit("on-change", result);
      }
    },
    created() {
      // this.findDict();
      this.text = this.value;
    },
    watch:{
      value(curVal,oldVal){
        this.text = curVal;
      },
      parentCode(curVal,oldVal){
        this.findDict();
      }
    },
    computed: {

    }
  }
</script>

<style lang="scss">
</style>
